<template>
  <v-app>
    <app-sidebar></app-sidebar>

    <v-content>
      <AppStatus v-show="$route.name !== 'home'"></AppStatus>
      <router-view />
      <!-- <app-notifications></app-notifications>-->
      <app-note v-show="showNotes"></app-note>
    </v-content>

    <v-footer :fixed="fixed" app>
      <span>&copy; {{new Date().getFullYear()}} Copyright: vonex.com.au</span>
    </v-footer>
  </v-app>
</template>
<script>
import Vue from "vue";
import Header from "./app-header";
import SideBar from "./app-sidebar";
import Notification from "./app-notification";
import Vue2Filters from "vue2-filters";
import moment from "moment";
import AppStatus from "@/components/app-status";
import { createNamespacedHelpers } from "vuex";
Vue.use(Vue2Filters);
var PhoneNumber = require("awesome-phonenumber");
Vue.component("app-header", Header);
Vue.component("app-sidebar", SideBar);
Vue.component("app-notifications", Notification);

import CustomerAddress from "./customer-address";
import MessageAlert from "./MessageAlert";
Vue.component("message-alert", MessageAlert);
import DatePicker from "vue2-datepicker";
Vue.component("date-picker", DatePicker);
import AppNote from "./app-note";
import Title from "../components/title.vue";
Vue.component("v-title", Title);
Vue.component("app-note", AppNote);
Vue.component("AppStatus", AppStatus);
Vue.component("customer-address", CustomerAddress);

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("orderStatus", function(value) {
  switch (value) {
    case 0:
      return "New";
    case 1:
      return "In Progress";
    case 2:
      return "Signed";
    case 3:
      return "Completed";
    case 4:
      return "Cancelled";
    case 5:
      return "Rejected";
    default:
      return "Unknown";
  }
});

Vue.use(VeeValidate, {
  events: "change"
});

export default {
  name: "root",
  data() {
    return {
      clipped: true,
      fixed: true,
      title: "Vonex",
      drawer: true
    };
  },
  computed: {
    showNotes() {
      return ["Summary", "OrderApprove"].indexOf(this.$route.name) < 0;
    }
  },
  name: "App"
};
</script>

